// eslint-disable @typescript-eslint/no-redeclare
import React from 'react';
import { Subtract } from 'utility-types';

import Polyglot from 'node-polyglot';
import englishTranslationWithoutComposableDevice from './en-without-composable.json';
import germanTranslationWithoutComposableDevice from './de-without-composable.json';
import spanishTranslationWithoutComposableDevice from './es-without-composable.json';
import frenchTranslationWithoutComposableDevice from './fr-without-composable.json';

import englishTranslation from './en.json';
import germanTranslation from './de.json';
import spanishTranslation from './es.json';
import frenchTranslation from './fr.json';
import moment from 'moment';
import 'moment/dist/locale/es';
import 'moment/dist/locale/fr';
import 'moment/dist/locale/de';
import _ from 'lodash';
import {
  forFringandDeTranslation,
  forFringandEnTranslation,
  forFringandEsTranslation,
  forFringandFrTranslation,
} from '../customized/fours-fringand-fr/i18n';

export { default as englishTranslation } from './en.json';
export { default as germanTranslation } from './de.json';
export { default as spanishTranslation } from './es.json';
export { default as frenchTranslation } from './fr.json';

/**
 * Compare if the object value is Falsy, if it is, return the source value
 */
function orComparatorSrc(objValue: any, srcValue: any) {
  return srcValue || objValue;
}

function getEnglishTranslations() {
  const variant = process.env.REACT_APP_FEATURE_TOGGLE_styledComponentsVariants;
  switch (variant) {
    case 'fours-fringand-fr':
      return _.merge(englishTranslation, forFringandEnTranslation);
    default:
      return englishTranslation;
  }
}

function getGermanTranslations() {
  const variant = process.env.REACT_APP_FEATURE_TOGGLE_styledComponentsVariants;
  switch (variant) {
    case 'fours-fringand-fr':
      return _.merge(germanTranslation, forFringandDeTranslation);
    default:
      return germanTranslation;
  }
}

function getFrenchTranslations() {
  const variant = process.env.REACT_APP_FEATURE_TOGGLE_styledComponentsVariants;
  switch (variant) {
    case 'fours-fringand-fr':
      return _.merge(frenchTranslation, forFringandFrTranslation);
    default:
      return frenchTranslation;
  }
}

function getSpanishTranslations() {
  const variant = process.env.REACT_APP_FEATURE_TOGGLE_styledComponentsVariantss;

  switch (variant) {
    case 'fours-fringand-fr':
      return _.merge(spanishTranslation, forFringandEsTranslation);
    default:
      return spanishTranslation;
  }
}

const mergedComposableEnglishTranslation = _.mergeWith(
  englishTranslationWithoutComposableDevice,
  getEnglishTranslations(),
  orComparatorSrc
);
const mergedComposableGermanTranslation = _.mergeWith(
  germanTranslationWithoutComposableDevice,
  getGermanTranslations(),
  orComparatorSrc
);
const mergedComposableSpanishTranslation = _.mergeWith(
  spanishTranslationWithoutComposableDevice,
  getSpanishTranslations(),
  orComparatorSrc
);
const mergedComposableFrenchTranslation = _.mergeWith(
  frenchTranslationWithoutComposableDevice,
  getFrenchTranslations(),
  orComparatorSrc
);

export type LanguagesSported = 'de' | 'en' | 'fr' | 'nl' | 'es';

/**
 * get I 18n
 * Load the translations
 */
const locales: Record<string, object> = {
  en:
    process.env.REACT_APP_FEATURE_TOGGLE_composableDevice === 'true'
      ? englishTranslation
      : mergedComposableEnglishTranslation,
  de:
    process.env.REACT_APP_FEATURE_TOGGLE_composableDevice === 'true'
      ? germanTranslation
      : mergedComposableGermanTranslation,
  es:
    process.env.REACT_APP_FEATURE_TOGGLE_composableDevice === 'true'
      ? spanishTranslation
      : mergedComposableSpanishTranslation,
  fr:
    process.env.REACT_APP_FEATURE_TOGGLE_composableDevice === 'true'
      ? frenchTranslation
      : mergedComposableFrenchTranslation,
};

const locale = 'en';
let language: LanguagesSported =
  (navigator.languages && navigator.languages[0]) ||
  navigator.language ||
  // @ts-ignore not safe type
  navigator.userLanguage;
if (!locales[language]) {
  language = language.toLowerCase().split(/[_-]+/)[0] as LanguagesSported;
}
/* if the language is not found in the availables locales, then we should use
be default en */
if (!locales[language]) {
  language = 'en';
}

const polyglot = new Polyglot({ phrases: locales[language], locale });

export const getLanguage = () => language;

export const getPolyglot = () => polyglot;

/* Set moment with the selected lang */
moment.locale(language);

export interface PolyglotComponentProps {
  polyglot: Polyglot;
}

export function withPolyglot<P extends PolyglotComponentProps>(
  WrappedComponent: React.ComponentType<P>
) {
  const displayName =
    (WrappedComponent as any).displayName ||
    WrappedComponent.name ||
    'Component';

  const WrappedComponentWithPolyglot = (
    props: Subtract<P, PolyglotComponentProps>
  ) => <WrappedComponent {...(props as P)} polyglot={polyglot} />;

  WrappedComponentWithPolyglot.displayName = `withPolyglot(${displayName})`;
  return WrappedComponentWithPolyglot;
}
